import React from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { Col } from "reactstrap";
import { Button, Row } from "../../../components/Component";
import FormCheckbox from "../../form-components/CheckboxComponent";

const UserAccessibilityModal: React.FC<any> = ({
  selectedViewDetailsName,
  data,
  onSave,
  onCancel,
}) => {
  console.log("{{{data", data, selectedViewDetailsName);
  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    reset,
  } = methods;

  const updatedAccessibilityOptions = [
    {
      label: "Create / Add",
      value: "ADD",
    },
    {
      label: "View",
      value: "VIEW",
    },
    {
      label: "Edit / Update",
      value: "EDIT",
    },
    {
      label: " Delete / Inactive",
      value: "CANCEL",
    },
    {
      label: "Approve / Reject",
      value: "APPROVE",
    },
  ];

  const onSubmit = (formValues: any) => {
    const prefix = `${selectedViewDetailsName}_`;

    // Step 1: Build permissionsMap
    const permissionsMap: Record<string, Record<string, number>> = {};

    Object.entries(formValues).forEach(([key, value]) => {
      if (!key.startsWith(prefix)) return;

      const [, moduleID, action] = key.split("_");
      if (!permissionsMap[moduleID]) {
        permissionsMap[moduleID] = {};
      }

      permissionsMap[moduleID][action] = value ? 1 : 0;
    });

    console.log("permissionsMap", permissionsMap);

    // Step 2: Set updated data
    const updatedData = {
      ...data,
      accessibility: data.accessibility.map((entry: any) => {
        if (entry.category !== selectedViewDetailsName) return entry;
        console.log("entry", entry);

        if (selectedViewDetailsName === "Reports") {
          // For Reports, modules are nested
          const updatedModules = entry.modules.map((subCat: any) => ({
            ...subCat,
            modules: subCat.modules.map((mod: any) => {
              const actions = permissionsMap[mod.moduleID];
              if (!actions) return mod;
              return {
                ...mod,
                actions: {
                  add: actions.add,
                  view: actions.view,
                  edit: actions.edit,
                  cancel: actions.cancel,
                  approve: actions.approve,
                  reject: actions.reject,
                },
                allowedToEdit: mod.allowedToEdit,
              };
            }),
          }));
          return { ...entry, modules: updatedModules };
        } else if (
          selectedViewDetailsName === "Masters" ||
          selectedViewDetailsName === "Dashboard"
        ) {
          const updatedModules = entry.modules.map((mod: any) => {
            const actions = permissionsMap[mod.moduleID];
            if (!actions) return mod;

            const isAddChecked = actions.add === 1;

            return {
              ...mod,
              actions: {
                add: isAddChecked ? 1 : 0,
                view: isAddChecked ? 1 : 0,
                edit: isAddChecked ? 1 : 0,
                cancel: isAddChecked ? 1 : 0,
                approve: isAddChecked ? 1 : 0,
                reject: isAddChecked ? 1 : 0,
              },
              allowedToEdit: mod.allowedToEdit,
            };
          });
          console.log("updatedModules", updatedModules);
          return {
            ...entry,
            modules: updatedModules,
          };
        } else {
          const updatedModules = entry.modules.map((mod: any) => {
            const modIdStr = mod.moduleID; // ensure string match
            const actions = permissionsMap[modIdStr];
            console.log("actions", actions);
            if (!actions) return mod; // untouched module
            return {
              ...mod,
              actions: {
                add: actions.add,
                view: actions.view,
                edit: actions.edit,
                cancel: actions.cancel,
                approve: actions.approve,
                reject: actions.reject,
              },
              allowedToEdit: mod.allowedToEdit,
            };
          });
          return {
            ...entry,
            modules: updatedModules,
          };
        }
      }),
    };
    onSave(updatedData);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Row className="gy-4">
            {selectedViewDetailsName === "Reports" ? (
              <>
                {/* Render one table per report sub-category */}
                {data.accessibility
                  ?.find((obj: any) => obj.category === selectedViewDetailsName)
                  ?.modules.map((reportCategory: any) => (
                    <div key={reportCategory.category}>
                      <h5>{reportCategory.category}</h5>
                      <table className="table table-hover" id="accessesbility">
                        <thead>
                          <tr>
                            <th>Sub Feature	</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportCategory.modules.map((item: any) => {
                            const actionTypes = [
                              // "add",
                              "view",
                              // "edit",
                              // "cancel",
                              // "approve",
                            ];
                            // Set default checkbox values on load
                            actionTypes.forEach((action) => {
                              const name = `${selectedViewDetailsName}_${item.moduleID}_${action}`;
                              const isChecked = Number(item.actions?.[action]) === 1;
                              setValue?.(name, isChecked);
                            });

                            return (
                              <tr key={item.moduleID}>
                                <td>{item.moduleName}</td>
                                {actionTypes.map((action) => {
                                  const name = `${selectedViewDetailsName}_${item.moduleID}_${action}`;
                                  const isDisabled =
                                    action !== "view" &&
                                    !item.allowedToEdit?.includes(action);
                                  return (
                                    <td key={name}>
                                      <FormCheckbox
                                        name={name}
                                        optionLabel=""
                                        noGap={true}
                                        size="small"
                                        disabled={isDisabled}
                                      />
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ))}
              </>
            ) : selectedViewDetailsName === "Masters" ||
              selectedViewDetailsName === "Dashboard" ? (
              <table className="table table-hover" id="accessesbility">
                <thead>
                  <tr>
                    <th>Sub-Feature</th>
                    <th>Accessibility</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const foundCategory = data.accessibility?.find(
                      (obj: any) => obj.category === selectedViewDetailsName
                    );
                    console.log(
                      "selectedViewDetailsName",
                      selectedViewDetailsName
                    );
                    if (!foundCategory) return null;
                    console.log("foundCategory", foundCategory);
                    return foundCategory.modules.map((mod: any, i: number) => {
                      const actionTypes = ["add"];
                      actionTypes.forEach((action) => {
                        const name = `${selectedViewDetailsName}_${mod.moduleID}_${action}`;
                        console.log("name", name);
                        const isChecked =
                          selectedViewDetailsName === "Masters"
                            ? Number(mod.actions?.[action]) === 1
                            : Number(mod.actions?.["view"]) === 1;
                        console.log("isChecked", isChecked);
                        setValue?.(name, isChecked);
                      });

                      return (
                        <tr key={mod.moduleID}>
                          <td>{mod.moduleName}</td>
                          {actionTypes.map((action) => {
                            const name = `${selectedViewDetailsName}_${mod.moduleID}_${action}`;
                            const isDisabled =
                              action !== "view" &&
                              !mod.allowedToEdit?.includes(action);
                            return (
                              <td key={name}>
                                <FormCheckbox
                                  name={name}
                                  optionLabel=""
                                  noGap={true}
                                  size="small"
                                  disabled={isDisabled}
                                />
                              </td>
                            );
                          })}
                        </tr>
                      );
                      //   }
                      // );
                    });
                  })()}
                </tbody>
              </table>
            ) : (
              <table className="table table-hover" id="accessesbility">
                <thead>
                  <tr>
                    <th>Sub Feature</th>
                    {updatedAccessibilityOptions.map((_item: any) => {
                      return <th key={_item.value}>{_item.label}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    if (!selectedViewDetailsName) return null;
                    const foundCategory = data.accessibility?.find(
                      (obj: any) => obj.category === selectedViewDetailsName
                    );
                    if (!foundCategory) return null;
                    return (
                      <>
                        {foundCategory?.modules?.map(
                          (item: any, index: number) => {
                            if (!item || !item.moduleID) return null;
                            setValue?.(
                              `${selectedViewDetailsName}_${item.moduleID}_add`,
                              Number(item?.actions?.add) === 1
                            );
                            setValue?.(
                              `${selectedViewDetailsName}_${item.moduleID}_view`,
                              Number(item?.actions?.view) === 1
                            );
                            setValue?.(
                              `${selectedViewDetailsName}_${item.moduleID}_edit`,
                              Number(item?.actions?.edit) === 1
                            );
                            setValue?.(
                              `${selectedViewDetailsName}_${item.moduleID}_cancel`,
                              Number(item?.actions?.cancel) === 1
                            );
                            setValue?.(
                              `${selectedViewDetailsName}_${item.moduleID}_approve`,
                              Number(item?.actions?.approve) === 1
                            );
                            return (
                              <tr key={`item-${index}`}>
                                <td>{item.moduleName}</td>
                                <td>
                                  <FormCheckbox
                                    name={`${selectedViewDetailsName}_${item.moduleID}_add`}
                                    disabled={
                                      !item?.allowedToEdit?.includes("add")
                                    }
                                    optionLabel=""
                                    noGap={true}
                                    size={"small"}
                                  />
                                </td>
                                <td>
                                  <FormCheckbox
                                    name={`${selectedViewDetailsName}_${item.moduleID}_view`}
                                    optionLabel=""
                                    noGap={true}
                                    size={"small"}
                                  />
                                </td>
                                <td>
                                  <FormCheckbox
                                    disabled={
                                      !item?.allowedToEdit?.includes("edit")
                                    }
                                    name={`${selectedViewDetailsName}_${item.moduleID}_edit`}
                                    optionLabel=""
                                    noGap={true}
                                    size={"small"}
                                  />
                                </td>
                                <td>
                                  <FormCheckbox
                                    disabled={
                                      !item?.allowedToEdit?.includes("cancel")
                                    }
                                    name={`${selectedViewDetailsName}_${item.moduleID}_cancel`}
                                    optionLabel=""
                                    noGap={true}
                                    size={"small"}
                                  />
                                </td>
                                <td>
                                  <FormCheckbox
                                    disabled={
                                      !item?.allowedToEdit?.includes("approve")
                                    }
                                    name={`${selectedViewDetailsName}_${item.moduleID}_approve`}
                                    optionLabel=""
                                    noGap={true}
                                    size={"small"}
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </>
                    );
                  })()}
                </tbody>
              </table>
            )}
          </Row>
          <div className="actions clearfix">
            <ul>
              <li>
                <Button color="primary" type="submit">
                  save
                </Button>
              </li>
              <li>
                <Button
                  type="button"
                  color="primary"
                  onClick={() => {
                    reset();
                    onCancel();
                  }}
                  className="btn-dim btn btn-secondary"
                >
                  Cancel
                </Button>
              </li>
            </ul>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default UserAccessibilityModal;
